// extracted by mini-css-extract-plugin
var _1 = "DraftsView-module__animatedBackground--T9voa";
var _2 = "DraftsView-module__container--fTcUg";
var _3 = "DraftsView-module__tab--xk2nT";
export { _1 as "animatedBackground", _2 as "container", _3 as "tab" }
